import { computed, readonly, ref } from 'vue';
import { defineStore } from 'pinia';

import type { SemboUser } from '../models/semboUser';
import { UserService } from '../services/userService/userService';

const userService = new UserService();

export const useUserStore = defineStore('UserStore', () => {
  window.addEventListener('semboUserLoggedIn', (event: Event) => {
    const customEvent = event as CustomEvent<{ user: SemboUser }>;
    if (customEvent.detail?.user) {
      semboUser.value = customEvent.detail.user;
    }
  });

  // State
  const semboUser = ref<SemboUser | undefined>(undefined);

  // Getters
  const isUserLoggedIn = computed<boolean>(() => semboUser.value !== undefined);

  // Actions
  function fetchSemboUser(): void {
    userService.fetchSemboUser().subscribe((data) => {
      semboUser.value = data;
    });
  }

  return {
    // State
    semboUser: readonly(semboUser),

    // Getters
    isUserLoggedIn,

    // Actions
    fetchSemboUser,
  };
});
